import { MdClose, MdReply } from 'react-icons/md'
import { HiSparkles } from 'react-icons/hi2'
import { InternalMessage } from '@/lib/api/internal-chat/internal-chat-api'

interface ReplyPreviewProps {
    message: InternalMessage
    onCancel: () => void
}

export default function ReplyPreview({ message, onCancel }: ReplyPreviewProps) {
    const senderName = message.isAiMessage
        ? 'Assistente IA'
        : message.sender?.name || 'Usuário'

    return (
        <div className="bg-base-200 border-l-4 border-secondary px-3 py-2 flex items-start gap-2">
            <MdReply className="text-secondary text-lg mt-0.5 flex-shrink-0" />
            <div className="flex-1 min-w-0">
                <div className="flex items-center gap-1 text-sm font-medium text-secondary">
                    {message.isAiMessage && (
                        <HiSparkles className="text-xs" />
                    )}
                    {senderName}
                </div>
                <p className="text-sm text-base-content/70 truncate">
                    {message.content}
                </p>
            </div>
            <button
                type="button"
                className="btn btn-ghost btn-xs btn-square"
                onClick={onCancel}
            >
                <MdClose />
            </button>
        </div>
    )
}
